import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=23e16c22&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"
import style0 from "./PostList.vue?vue&type=style&index=0&id=23e16c22&prod&lang=scss&scoped=true"
import style1 from "./PostList.vue?vue&type=style&index=1&id=23e16c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e16c22",
  null
  
)

export default component.exports